import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { Observable } from 'rxjs';
import { ProdutoEtapaModalidadeService } from '../services/produto-etapa-modalidade.service';

@Injectable({
  providedIn: 'root',
})
export class ProdutoEtapaModalidadeResolver implements Resolve<boolean> {
  constructor(private service: ProdutoEtapaModalidadeService) {}

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    return this.service.getById(route.params.id);
  }
}

@Injectable({
  providedIn: 'root',
})
export class ProdutoEtapaModalidadeListResolver implements Resolve<boolean> {
  constructor(private service: ProdutoEtapaModalidadeService) {}

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    return this.service.findAll();
  }
}
